import { BaseUpdateComponent, BaseDataService, InputComponent, QueryParameter, NumberInputComponentV3, UserService, ModalService, NotificationService, ErrorHandlerService, ConfirmationDialogButtons } from 'yt-ng-framework';
import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';
import { Subject } from 'rxjs';
import * as var_config from '../../var_config';
import { List } from 'immutable';
import { RobaView } from 'src/app/lookups/roba/roba-view';
import { HttpErrorResponse } from '@angular/common/http';
import { Komitent } from 'src/app/lookups/komitent/komitent';
import { KomitentView } from 'src/app/lookups/komitent/komitent-view';
import { FormGroup, Validators } from '@angular/forms';
import { KomitentVoziloView } from 'src/app/lookups/komitent-vozilo/komitent-vozilo-view';
import { EOtpremnicaPrevoz } from './eotpremnica-prevoz';
import { EOtpremnicaService } from './eotpremnica-service';
import { Mesto } from 'src/app/lookups/mesto/mesto';

@Component({
  selector: 'yt-eotpremnica-prevoz-update',
  templateUrl: './eotpremnica-prevoz-update.component.html'
})
export class EOtpremnicaPrevozUpdateComponent
  extends BaseUpdateComponent<EOtpremnicaPrevoz>
  implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  varConfig = var_config;
  // pretplacenNaPromene: boolean = false;
  //   robaItems: List<RobaView>;
  izlazna: boolean = true;
  //   trebaTipPakovanja: boolean = false;
  //   parameterListZaKategoriju: List<QueryParameter> = List([]);
  parameterList: List<QueryParameter> = List([]);
  PrevoznikID: QueryParameter = new QueryParameter();
  razvoj: boolean = true;
  primaocItems: List<KomitentView>;
  mestoNaziv: string = "";
  KomitentID: QueryParameter = new QueryParameter();

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected otpremnicaService: EOtpremnicaService,
    protected decimalPipe: DecimalPipe,
    protected userService: UserService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected modalService: ModalService,
    protected errorService: ErrorHandlerService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService, modalService);

  }

  // @Input() sopstveniPrevoz: boolean = false;
  // @Input() firmaData: any;

  PrimaocGetItems(items) {
    this.primaocItems = items;
  }


  ngOnInit() {
    super.ngOnInit();

   

    // this.baseFormGroup.get('PrevoznikID')?.valueChanges.subscribe(value => {
    //     if (value){
    //      // this.KomitentID.Name="KomitentID";
    //      // this.KomitentID.Value=value;
    //       this.voziloAddParams.clear();
    //       this.voziloAddParams = List([new QueryParameter('KomitentID', value)]); 
    //       this.voziloAddParams = this.voziloAddParams.push(this.KomitentID);
    //     }
    // });


    // this.addValidatorToFc('EOtpremnicaID', Validators.required, 'required', 'EOTPREMNICA.ID.VALIDATION.REQUIRED');
    this.addValidatorToFc('PrevoznikID', Validators.required, 'required', 'EOTPREMNICA.PREVOZNIKID.VALIDATION.REQUIRED');
    this.addValidatorToFc('PrevoznikVoziloID', Validators.required, 'required', 'EOTPREMNICA.PREVOZNIKVOZILOID.VALIDATION.REQUIRED');
    this.addValidatorToFc('NazivPrevoznika', Validators.required, 'required', 'EOTPREMNICAPREVOZ.NAZIVPREVOZNIKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('BrojVoznje', Validators.required, 'required', 'EOTPREMNICAPREVOZ.BROJVOZNJE.VALIDATION.REQUIRED');
    this.addValidatorToFc('PibPrevoznika', Validators.required, 'required', 'EOTPREMNICAPREVOZ.PIBPREVOZNIKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('UlicaPrevoznika', Validators.required, 'required', 'EOTPREMNICAPREVOZ.ULICAPREVOZNIKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('GradPrevoznika', Validators.required, 'required', 'EOTPREMNICAPREVOZ.GRADPREVOZNIKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('PostanskiBrojPrevoznika', Validators.required, 'required', 'EOTPREMNICAPREVOZ.POSTANSKIBROJPREVOZNIKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('MaticniBrojPrevoznika', Validators.required, 'required', 'EOTPREMNICAPREVOZ.MATICNIBROJPREVOZNIKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('TipDokumentaVozaca', Validators.required, 'required', 'EOTPREMNICAPREVOZ.TIPDOKUMENTAVOZACA.VALIDATION.REQUIRED');
//    this.addValidatorToFc('PocetnaLokacijaPrevoznika', Validators.required, 'required', 'EOTPREMNICAPREVOZ.TIPDOKUMENTAVOZACA.VALIDATION.REQUIRED');
//    this.addValidatorToFc('PretovarnaTackaPrevoznika', Validators.required, 'required', 'EOTPREMNICAPREVOZ.TIPDOKUMENTAVOZACA.VALIDATION.REQUIRED');
    this.addValidatorToFc('RegistarskiBrojPrevoznika', Validators.required, 'required', 'EOTPREMNICAPREVOZ.REGISTARSKIBROJPREVOZNIKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('VozacBrojVozackeDozvole', Validators.required, 'required', 'EOTPREMNICAPREVOZ.VOZACBROJVOZACKEDOZVOLE.VALIDATION.REQUIRED');
    this.addValidatorToFc('PrevoznikPocetnaLokacijaID', Validators.required, 'required', 'EOTPREMNICAPREVOZ.POCETNALOKACIJAPREVOZNIKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('PrevoznikPretovarnaTackaID', Validators.required, 'required', 'EOTPREMNICAPREVOZ.PRETOVARNATACKAPREVOZNIKA.VALIDATION.REQUIRED');

    // docs: docs/event-flows/eotpremnica-prevoz-update.md
    this.IDProcessed
      .subscribe((value) => {
        if (!value) return;

        if(!this.baseFormGroup.get("PrevoznikID").value){
          this.baseFormGroup.get("PrevoznikVoziloID").disable();
          this.baseFormGroup.get("PrevoznikVoziloID").updateValueAndValidity();
        }        

        // this.getRbr();
        if (this.Item.ID === -1) {
          this.getRbr();
        }

         if (this.Parameters && this.Parameters.get(1))
          this.izlazna = Boolean(this.Parameters.get(1).get(0).Value);

        // čim je forma spremna, probaj da povučeš parametre iz parenta
        if (this.Parameters && this.Parameters.get(2)) {

          const paramList = this.Parameters.get(2);

          const sopstveni = paramList.find(p => p.Name === 'sopstveniPrevoz');
          const firma = paramList.find(p => p.Name === 'firmaData');

          const toBool = (v: any) =>
            v === true || v === 'true' || v === 1 || v === '1';

          const firmaData = firma?.Value as any;

          if (this.Item.ID === -1 && toBool(sopstveni?.Value) && firmaData) {
            
            this.baseFormGroup.patchValue(firmaData);
            this.baseFormGroup.updateValueAndValidity({ emitEvent: false });

            if (firmaData?.PibPrevoznika && this.primaocItems?.size > 0) {
              const pib = String(firmaData.PibPrevoznika).trim();
              const match = this.primaocItems.find(k =>
                String(k.Pib).trim() === pib
              );
              if (match) {
                this.baseFormGroup.get('PrevoznikID')?.patchValue(match.ID);

                this.parameterList = List([]);
                //this.PrevoznikID.Name = 'komitentid';
                this.PrevoznikID.Name = 'KomitentID';
                this.PrevoznikID.Value = match.ID;
                this.parameterList = this.parameterList.push(this.PrevoznikID);

                this.TransferParameters = (this.TransferParameters ?? List<List<QueryParameter>>())
                  .set(0, this.parameterList);
              }
            }

            // if (firmaData.PrevoznikID) {
            //   this.baseFormGroup.get('PrevoznikID')?.patchValue(firmaData.PrevoznikID);
            //   setTimeout(() => {
            //       if (this.cmbPrevoznik) {
            //           this.cmbPrevoznik.SelectItemByID(firmaData.PrevoznikID);
            //       }
            //   });

            //   this.parameterList = List([]);
            //   this.PrevoznikID.Name = 'komitentid';
            //   this.PrevoznikID.Value = firmaData.PrevoznikID;
            //   this.parameterList = this.parameterList.push(this.PrevoznikID);

            //   // this.TransferParameters = this.TransferParameters.set(0, this.parameterList);
            //   this.TransferParameters = (this.TransferParameters ?? List<List<QueryParameter>>())
            //     .set(0, this.parameterList);

            // }

          }
        }

        if (value) {
          // if (this.Item.ID == -1 && this.sopstveniPrevoz && this.firmaData) {
          //     this.baseFormGroup.patchValue({
          //         NazivPrevoznika: this.firmaData.NazivPrevoznika,
          //         PibPrevoznika: this.firmaData.PibPrevoznika,
          //         MaticniBrojPrevoznika: this.firmaData.MaticniBrojPrevoznika,
          //         UlicaPrevoznika: this.firmaData.UlicaPrevoznika,
          //         GradPrevoznika: this.firmaData.GradPrevoznika,
          //         PostanskiBrojPrevoznika: this.firmaData.PostanskiBrojPrevoznika
          //     });

          //     this.baseFormGroup.updateValueAndValidity();
          // }

          if (this.Item.ID == -1) {
            this.baseFormGroup.get('TipDokumentaVozaca').patchValue('Vozačka dozvola');
            this.baseFormGroup.get('TipDokumentaVozaca').updateValueAndValidity();
          }

          if (!Boolean(this.Parameters.get(1).get(0).Value)) {
            this.baseFormGroup.disable();
            this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
          }

        }

      })

  }

  getRbr() {
    if (this.Item.ID == -1 && this.ParentProperty && this.ParentProperty.Value) {
      let EOtpremnicaID = this.ParentProperty.Value;
      this.baseDataService.Get('EOtpremnicaPrevoz'
        , 'GetNextItemNumByEOtpremnicaID'
        , [new QueryParameter('eotpremnicaID', EOtpremnicaID)]
        , null)
        .subscribe(data => {
          this.baseFormGroup.get('BrojVoznje').patchValue(data);
          this.baseFormGroup.get('BrojVoznje').updateValueAndValidity();
        },
          error => {
            if (error instanceof HttpErrorResponse) {
              let _message;
              _message = this.errorService.getServerMessage(error);

              this.translateService.get(_message)
                .subscribe(translate => {
                  this.modalService.ShowConfirmationDialog("Problemi kod preuzimanja", translate, "warning", ConfirmationDialogButtons.Ok);
                  this.ResetValues(true, false);
                });
            }
          }
        )

    }
  }

  ngOnDestroy() { }

  onPrevoznikSelect(value: KomitentView) {
    if (value){
      // Ako se menja prevoznik resetuje se lista vozila
      this.baseFormGroup.get("PrevoznikVoziloID").enable();
      this.baseFormGroup.get("PrevoznikVoziloID")?.patchValue(null);
      this.baseFormGroup.get('NazivPrevoznika').updateValueAndValidity();

      this.parameterList = List([]);
      this.PrevoznikID.Name = "KomitentID";
      this.PrevoznikID.Value = value.ID;
      this.parameterList = this.parameterList.push(this.PrevoznikID)
      // this.TransferParameters = this.TransferParameters.set(0, this.parameterList);
      this.TransferParameters = (this.TransferParameters ?? List<List<QueryParameter>>())
        .set(0, this.parameterList);
      this.baseFormGroup.get("NazivPrevoznika")?.patchValue(value.SNaziv);
      this.baseFormGroup.get('NazivPrevoznika').updateValueAndValidity();
      this.baseFormGroup.get("UlicaPrevoznika")?.patchValue(value.Adresa);
      this.baseFormGroup.get('UlicaPrevoznika').updateValueAndValidity();
      this.baseFormGroup.get("PostanskiBrojPrevoznika")?.patchValue(value.PostBroj);
      this.baseFormGroup.get('PostanskiBrojPrevoznika').updateValueAndValidity();
      this.baseFormGroup.get("GradPrevoznika")?.patchValue(value.Mesto);
      this.baseFormGroup.get('GradPrevoznika').updateValueAndValidity();
      this.baseFormGroup.get("PibPrevoznika")?.patchValue(value.Pib);
      this.baseFormGroup.get('PibPrevoznika').updateValueAndValidity();
      this.baseFormGroup.get("MaticniBrojPrevoznika")?.patchValue(value.MaticniBroj);
      this.baseFormGroup.get('MaticniBrojPrevoznika').updateValueAndValidity();
    }

  }

  onVoziloSelect(value: KomitentVoziloView) {
    if (value){
      // this.baseFormGroup.get("PrevoznikVoziloID")?.patchValue(value.ID);
      // this.baseFormGroup.get('PrevoznikVoziloID').updateValueAndValidity();
      this.baseFormGroup.get("RegistarskiBrojPrevoznika")?.patchValue(value.RgBr);
      this.baseFormGroup.get('RegistarskiBrojPrevoznika').updateValueAndValidity();
    }
  }

    //onMestoSelected(value:Mesto){
    onMestoSelected(event: any, tip: string){
        //this.mestoNaziv = value.Naziv;        
      const selected = event?.item || event;



        if (tip == 'pocetna')
        {
          this.baseFormGroup.patchValue({
            PocetnaLokacijaPrevoznika: selected.Naziv
          });
        }
        
        if (tip == 'krajnja')
        {
          this.baseFormGroup.patchValue({
            PretovarnaTackaPrevoznika: selected.Naziv
          });
        }

    } 
}
